import { IMessage } from '@v2/domains/chat/types/chat.types'

import { ITask } from '../task/task.types'

export enum EscalationProgramEnum {
  DRIVERS_BENEFIT = 'drivers benefit',
  BCF = 'black car fund',
  DRIVERS_GUILD = 'drivers guild',
}

export enum EscalationStatusEnum {
  CREATED = 'created',
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  REVIEW = 'under review',
  SENT = 'sent to partner',
  PENDING = 'driver_pending',
  RESOLVED = 'resolved',
}

export enum EscalationIssueEnum {
  UTILIZATION = 'Utilization Issue (Health & Wellness Benefits)',
  HEALTH = 'Health-Related Income Protection Benefits',
  ENROLLMENT = 'Enrollment/Eligibility Issue',
  OTHER = 'Other',
  COMPENSATION = "Workers' Compensation and Death & Survivor Benefits",
  EDUCATION = 'Driver Education Program',
  CLASSES = 'Classes',
  APP = 'App Deactivation Assistance',
  MEMBERSHIP = 'IDG Membership',
  ORGANAZING = 'Organizing',
}

export interface FormSubmissionDto {
  templateId?: string
  email?: string
  payload?: { steps: { fields: IFormField[] }[] }
  isCompleted?: boolean
  isReviewed?: boolean
  version?: string
  id?: string
  personId?: string
}
export interface IEscalation extends ITask {
  id: string
  program: EscalationProgramEnum
  formStatus: EscalationStatusEnum
  issue: EscalationIssueEnum
  service: string
  form: FormSubmissionDto
}

export type FormEscalationAttachments = {
  url?: string
  id?: string
  name: string
  size: number
  error?: string
  type: string
}[]

export type MutateEscalationData = Partial<
  Omit<
    IEscalation,
    'activityDate' | 'updatedAt' | 'createdAt' | 'activityDate' | 'issue'
  >
> & {
  updatedAt?: Date | null | string
  createdAt?: Date | null | string
  issue?: EscalationIssueEnum | null
  notes?: IMessage[]
  formFields?: { [key: string]: unknown } & { files: FormEscalationAttachments }
}

export const ESCALATION_PROGRAM_OPTIONS = [
  {
    label: 'Drivers Benefit',
    value: EscalationProgramEnum.DRIVERS_BENEFIT,
    header: 'Drivers Benefits - Enrollment/Eligibility Issue',
    headerText: `<span> If driver is interested in an <strong>Activity Exemption</strong>, they must:</span>
    <ol>
    <li>Provide proof of circumstances (ex: recovering from accident, illness, receiving Workers’ Comp, etc.) </li>
    <li>Verify that they are unable to drive (ex: medical records/notes indicating that they are still recovering, etc.) </li>
    <li> Share driving history (how long have they been a driver) </li>
    <li> Send any additional documentation that verifies they were actively driving before the accident/illness occurred (ex: Uber activity prior to an accident)</li>
    <li> Confirm which benefit(s) they are interested in accessing</li>
    </ol>
    <hr />
    <strong>To ensure the Escalations Team can help this driver more effectively, include as many details as possible, such as:</strong></br>
    <ul>
      <li>The benefit or service the driver is calling about</li>
      <li>Any relevant dates, names, locations, and history</li>
      <li>Related documents (ex: invoices/bills, eligibility verification, and screenshots)</li>
    </ul>
      `,
  },
  {
    label: 'Black Car Fund',
    value: EscalationProgramEnum.BCF,
    header: 'The Black Car Fund - Driver Education Program',
    headerText: `<span> Record Class Name, Date, Location, and Inquiry.</span><br/><br/><hr/>
    <strong>To ensure the Escalations Team can help this driver more effectively, include as many details as possible, such as:</strong> <br/>
    <ul>
      <li>The benefit or service the driver is calling about</li>
      <li>Any relevant dates, names, locations, and history</li>
      <li>Related documents (ex: invoices/bills, eligibility verification, and screenshots)</li>
    </ul>
      `,
  },
  {
    label: 'Drivers Guild',
    value: EscalationProgramEnum.DRIVERS_GUILD,
    header: 'The Independent Drivers Guild - Organizing',
    headerText: `<span> Includes wanting to get involved, or connect/follow up with a specific Organizer.</span><br/><br/><hr/>
    <strong>To ensure the Escalations Team can help this driver more effectively, include as many details as possible, such as:</strong> <br/>
    <ul>
      <li>The benefit or service the driver is calling about</li>
      <li>Any relevant dates, names, locations, and history</li>
      <li>Related documents (ex: invoices/bills, eligibility verification, and screenshots)</li>
    </ul>
      `,
  },
]

export const ESCALATION_ISSUE_OPTIONS = [
  {
    label: EscalationIssueEnum.UTILIZATION,
    value: EscalationIssueEnum.UTILIZATION,
    program: EscalationProgramEnum.DRIVERS_BENEFIT,
  },
  {
    label: EscalationIssueEnum.HEALTH,
    value: EscalationIssueEnum.HEALTH,
    program: EscalationProgramEnum.DRIVERS_BENEFIT,
  },
  {
    label: EscalationIssueEnum.ENROLLMENT,
    value: EscalationIssueEnum.ENROLLMENT,
    program: EscalationProgramEnum.DRIVERS_BENEFIT,
  },
  {
    label: EscalationIssueEnum.OTHER,
    value: EscalationIssueEnum.OTHER,
  },
  {
    label: EscalationIssueEnum.COMPENSATION,
    value: EscalationIssueEnum.COMPENSATION,
    program: EscalationProgramEnum.BCF,
  },
  {
    label: EscalationIssueEnum.EDUCATION,
    value: EscalationIssueEnum.EDUCATION,
    program: EscalationProgramEnum.BCF,
  },
  {
    label: EscalationIssueEnum.CLASSES,
    value: EscalationIssueEnum.CLASSES,
    program: EscalationProgramEnum.DRIVERS_GUILD,
  },
  {
    label: EscalationIssueEnum.APP,
    value: EscalationIssueEnum.APP,
    program: EscalationProgramEnum.DRIVERS_GUILD,
  },
  {
    label: EscalationIssueEnum.MEMBERSHIP,
    value: EscalationIssueEnum.MEMBERSHIP,
    program: EscalationProgramEnum.DRIVERS_GUILD,
  },
  {
    label: EscalationIssueEnum.ORGANAZING,
    value: EscalationIssueEnum.ORGANAZING,
    program: EscalationProgramEnum.DRIVERS_GUILD,
  },
]

export interface IFormField {
  label: string
  name: string
  required: true
  type: 'textArea' | 'select' | 'multiSelect' | 'fileUploader' | 'datePicker'
  value: unknown
}
export interface IFormTemplate {
  isProcessabel?: boolean
  notifyEmails: {}
  url?: string
  type?: 'public' | 'private'
  name?: string
  version?: string
  userId?: string
  organizationId?: string
  id?: string
  payload: { steps: [{ fields: IFormField[] }] }
  processingStrategy?: string
}

export const ESCALATION_SERVICE_OPTIONS = [
  {
    label: 'GVS Vision',
    value: 'GVS Vision',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Metlife Dental',
    value: 'Metlife Dental',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Hearing Care Program (TruHearing)',
    value: 'Hearing Care Program (TruHearing)',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Medical Clinics (ModernMD)',
    value: 'Medical Clinics (ModernMD)',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Virtual Primary Care (CirrusMD)',
    value: 'Virtual Primary Care (CirrusMD)',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Healthcare Enrollment',
    value: 'healthcare enrollment',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Prescription Discounts (Capital Rx)',
    value: 'Prescription Discounts (Capital Rx)',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Urgent Care Discounts (MedRite)',
    value: 'Urgent Care Discounts (MedRite)',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Diagnostic Imaging Discounts (Galaxy Network)',
    value: 'Diagnostic Imaging Discounts (Galaxy Network)',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Free Flu Shot Voucher Program',
    value: 'Free Flu Shot Voucher Program',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Other Benefit',
    value: 'Other Benefit',
    issue: EscalationIssueEnum.UTILIZATION,
  },
  {
    label: 'Metlife Critical Illness Insurance',
    value: 'Metlife Critical Illness Insurance',
    issue: EscalationIssueEnum.HEALTH,
  },
  {
    label: 'Metlife Personal Accident Insurance',
    value: 'Metlife Personal Accident Insurance',
    issue: EscalationIssueEnum.HEALTH,
  },
  {
    label: 'The Hartford Accident Disability Insurance',
    value: 'The Hartford Accident Disability Insurance',
    issue: EscalationIssueEnum.HEALTH,
  },
  {
    label: 'The Hartford $100K Accidental Death Benefit',
    value: 'The Hartford $100K Accidental Death Benefit',
    issue: EscalationIssueEnum.HEALTH,
  },
  {
    label: 'Defensive Driving Course (DDC)',
    value: 'Defensive Driving Course (DDC)',
    issue: EscalationIssueEnum.EDUCATION,
  },
  {
    label: 'Wellness STEP Course',
    value: 'Wellness STEP Course',
    issue: EscalationIssueEnum.EDUCATION,
  },
  {
    label: 'Driver Education Course',
    value: 'Driver Education Course',
    issue: EscalationIssueEnum.EDUCATION,
  },
]

export const ESCALATION_STATUS_OPTIONS = [
  {
    label: 'Created',
    value: EscalationStatusEnum.CREATED,
    disabled: true,
  },
  {
    label: 'Draft',
    value: EscalationStatusEnum.DRAFT,
    disabled: false,
  },
  {
    label: 'Submitted',
    value: EscalationStatusEnum.SUBMITTED,
    disabled: false,
  },
  {
    label: 'Under Review',
    value: EscalationStatusEnum.REVIEW,
    disabled: true,
  },
  {
    label: 'Sent to Partner / Provider',
    value: EscalationStatusEnum.SENT,
    disabled: true,
  },
  {
    label: 'Waiting for Driver Response',
    value: EscalationStatusEnum.PENDING,
    disabled: true,
  },
  {
    label: 'Resolved',
    value: EscalationStatusEnum.RESOLVED,
    disabled: true,
  },
]

export enum UpdateFormSubmitter {
  SAVE = 'save',
  SUBMIT = 'submit',
  SAVE_DRAFT = 'draft',
}
